'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useHaptic } from '@/hooks/useHaptic';
import { useAffiliateClick } from '../../../_hooks/useAffiliateClick';
import { appendRoParticle } from '../../../_utils/appendRoParticle';
import type { AffiliateChannelType, AffiliateOpenMode, AppGuideModalPolicy } from '../../../_utils/resolveAffiliateClick';
interface MerchantEarnButtonProps {
  merchantCode: string;
  merchantName: string;
  logoImageUrl: string;
  modalText?: string | null;
  appGuideModalPolicy: AppGuideModalPolicy;
  openMode: AffiliateOpenMode;
  channelType: AffiliateChannelType;
}
export const MerchantEarnButton = t0 => {
  const $ = _c(5);
  const {
    appGuideModalPolicy,
    openMode,
    channelType,
    ...guide
  } = t0;
  const {
    startAffiliateClick,
    isPending
  } = useAffiliateClick();
  const {
    triggerHaptic
  } = useHaptic();
  const handleClick = () => {
    triggerHaptic();
    startAffiliateClick({
      target: {
        type: "merchant"
      },
      entryPointType: "MERCHANT_DETAIL",
      appGuideModalPolicy,
      openMode,
      channelType,
      guide: {
        ...guide,
        showDetailLink: false
      }
    });
  };
  const T0 = Button;
  const t1 = "w-full";
  const t2 = appendRoParticle(guide.merchantName);
  let t3;
  if ($[0] !== T0 || $[1] !== handleClick || $[2] !== isPending || $[3] !== t2) {
    t3 = <T0 className={t1} disabled={isPending} onClick={handleClick}>{t2} 이동하고 적립받기</T0>;
    $[0] = T0;
    $[1] = handleClick;
    $[2] = isPending;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};